import type { UseFormReturn } from 'react-hook-form';
import { FormDialog } from '../../../components/ui/FormDialog';
import { MEMBERSHIP_TYPE_LABELS, PERSON_STATUS_LABELS } from '../../../shared/labels';
import { Field, inputCss, primaryBtn, secondaryBtn, type CreateForm } from './pessoa-list.support';

export function PessoaCreateDialog({
  form,
  mutation,
  onCreate,
  onClose,
}: {
  form: UseFormReturn<CreateForm>;
  mutation: { isPending: boolean; isError: boolean; error: unknown };
  onCreate: () => void;
  onClose: () => void;
}) {
  return (
    <FormDialog title="Nova pessoa" busy={mutation.isPending} onClose={onClose}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          onCreate();
        }}
        style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}
      >
        <Field label="Nome civil *" error={form.formState.errors.civilName?.message}>
          <input {...form.register('civilName')} style={inputCss} placeholder="Nome completo" />
        </Field>
        <Field label="Nome social / de exibição">
          <input
            {...form.register('socialName')}
            style={inputCss}
            placeholder="Como a pessoa prefere ser chamada"
          />
        </Field>
        <Field label="E-mail" error={form.formState.errors.email?.message}>
          <input {...form.register('email')} style={inputCss} type="email" />
        </Field>
        <Field label="Telefone">
          <input {...form.register('phone')} style={inputCss} />
        </Field>
        <Field label="Tipo de vínculo">
          <select {...form.register('membershipType')} style={inputCss}>
            {Object.entries(MEMBERSHIP_TYPE_LABELS).map(([v, l]) => (
              <option key={v} value={v}>
                {l}
              </option>
            ))}
          </select>
        </Field>
        <Field label="Situação inicial">
          <select {...form.register('status')} style={inputCss}>
            {Object.entries(PERSON_STATUS_LABELS).map(([v, l]) => (
              <option key={v} value={v}>
                {l}
              </option>
            ))}
          </select>
        </Field>
        {mutation.isError && (
          <p role="alert" style={{ color: 'var(--danger)', fontSize: '0.8rem', margin: 0 }}>
            {mutation.error instanceof Error && mutation.error.message
              ? mutation.error.message
              : 'Não foi possível cadastrar a pessoa. Verifique os dados e tente novamente.'}
          </p>
        )}
        <div
          style={{
            display: 'flex',
            gap: '0.5rem',
            justifyContent: 'flex-end',
            marginTop: '0.5rem',
          }}
        >
          <button
            type="button"
            disabled={mutation.isPending}
            onClick={onClose}
            style={secondaryBtn}
          >
            Cancelar
          </button>
          <button type="submit" disabled={mutation.isPending} style={primaryBtn}>
            {mutation.isPending ? 'Salvando...' : 'Cadastrar'}
          </button>
        </div>
      </form>
    </FormDialog>
  );
}
